/*
 *
 * Ctydents reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE,
  LOAD_COURSES,
  LOAD_COURSES_SUCCESS,
  LOAD_COURSES_ERROR,
  UPDATE_COURSE,
  UPDATE_COURSE_SUCCESS,
  UPDATE_COURSE_ERROR,
  HARD_DELETE_COURSE,
  HARD_DELETE_COURSE_SUCCESS,
  HARD_DELETE_COURSE_ERROR,
} from './constants';

export const initialState = {
  firstRender: true,
  loading: false,
  error: false,
  courseDetail: false,
  itemsList: false,
  firstElem: false,
  loadingUpdate: false,
  // hard Delete
  hardDeleteCourseId: null,
  hardDeleteDetail: false,
  hardDeleteLoading: false,
  hardDeleteError: false,
};

import { notification } from 'antd';

/* eslint-disable default-case, no-param-reassign */
const coursesReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE:
        return initialState;

      case LOAD_COURSES:
        draft.loading = true;
        draft.error = false;
        draft.firstRender = true;
        draft.itemsList = false;
        draft.firstElem = false;
        break;
      case LOAD_COURSES_SUCCESS:
        draft.loading = false;
        draft.firstRender = false;
        draft.itemsList = action.itemsList;
        draft.firstElem = action.itemsList?.data[0] || null;
        break;
      case LOAD_COURSES_ERROR:
        draft.error = action.error;
        draft.loading = false;
        draft.firstRender = false;
        draft.itemsList = false;
        draft.firstElem = false;
        break;

      // Update for Single Element
      case UPDATE_COURSE:
        draft.loadingUpdate = true;
        draft.error = false;
        draft.courseDetail = action.courseDetail;
        break;
      case UPDATE_COURSE_SUCCESS:
        draft.loadingUpdate = false;
        const { courseDetail } = action;

        if (courseDetail?._id) {
          draft.courseDetail = action.courseDetail;

          let listData = draft.itemsList.data;
          let index = draft.itemsList.data.findIndex(
            po => po._id === courseDetail._id,
          );
          index !== -1
            ? (listData[index] = courseDetail)
            : listData.unshift(courseDetail);
          
          draft.itemsList = { ...draft.itemsList, data: listData };
        } else {
          draft.courseDetail = false;
          if (courseDetail?.code == 500) {
            notification.warning({
              message: `Quelque chose s'est mal passé`,
              description: courseDetail?.message,
            });
          } else if (courseDetail?.code == 200) {
            const existingCourse = courseDetail?.data;
            notification.info({
              message: `Ce cours existe déjà: ${
                existingCourse?.subject?.name
              }`,
              description: courseDetail?.message,
            });
          }
        }

        break;
      case UPDATE_COURSE_ERROR:
        draft.error = action.error;
        draft.loadingUpdate = false;
        break;

      // Hard Delete for Single Element
      case HARD_DELETE_COURSE:
        draft.hardDeleteLoading = true;
        draft.hardDeleteError = false;
        draft.hardDeleteCourseId = action.hardDeleteCourseId;
        break;
      case HARD_DELETE_COURSE_SUCCESS:
        draft.hardDeleteLoading = false;
        draft.hardDeleteError = false;
        const { hardDeleteDetail } = action;

        if (hardDeleteDetail.hasOwnProperty('deletedIDs')) {
          draft.hardDeleteDetail = action.hardDeleteDetail;

          let listData = draft.itemsList.data;
          let index = draft.itemsList.data.findIndex(
            po => po._id === draft.hardDeleteCourseId,
          );
          if (index !== -1) {
            listData.splice(index, 1);
          }
          draft.itemsList = { ...draft.itemsList, data: listData };
        }

        break;
      case HARD_DELETE_COURSE_ERROR:
        draft.hardDeleteError = action.hardDeleteError;
        draft.hardDeleteLoading = false;
        break;
    }
  });

export default coursesReducer;
